import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '@core/auth/services/auth.service';
import { ADMIN_MENU_ITEMS } from '@core/constants/menu.constant';
import { UserProfile } from '@core/models/user.model';

@Component({
  selector: 'app-admin-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './admin-sidebar.html',
  styleUrl: './admin-sidebar.scss',
})
export class AdminSidebar {
  private readonly authService = inject(AuthService);

  protected readonly menuItems = ADMIN_MENU_ITEMS;
  protected userProfile: UserProfile | null | undefined;

  constructor() {
    this.authService.userProfile$.subscribe((profile) => {
      this.userProfile = profile;
    });
  }

  protected logout(): void {
    void this.authService.logout();
  }

  protected userName(): string {
    return this.userProfile?.firstName || this.userProfile?.displayName || 'Admin User';
  }

  protected userEmail(): string {
    return this.userProfile?.profileIdentifiers?.[0]?.emailId || '';
  }

  protected userInitials(): string {
    const name = this.userName();
    return name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }
}
